import { useState } from "react";

import { MessageFolder } from "@asd/customer-portal-api";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import { Box, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";

import { FOLDER_ICONS, FOLDERS } from "./helpers";

interface MoveToMenuProps {
  currentFolder: MessageFolder;
  onMove: (target: MessageFolder) => void;
  disabled?: boolean;
}

const MoveToMenu = ({ currentFolder, onMove, disabled }: MoveToMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const targets = FOLDERS.filter((f) => f !== currentFolder);

  return (
    <>
      <Tooltip title="Move to">
        <IconButton disabled={disabled} onClick={(e) => setAnchorEl(e.currentTarget)} size="small">
          <DriveFileMoveOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} onClose={() => setAnchorEl(null)} open={Boolean(anchorEl)}>
        {targets.map((f) => (
          <MenuItem
            key={f}
            onClick={() => {
              onMove(f);
              setAnchorEl(null);
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {FOLDER_ICONS[f]}
              {f}
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MoveToMenu;
